import { createRouter, createWebHistory } from "vue-router";
import Default from "../views/dashboards/Default.vue";
import OidcCallback from '@/views/OidcCallback';
import store from '@/store';
import { vuexOidcCreateRouterMiddleware } from "vuex-oidc";

const routes = [
  {
    path: "/",
    name: "/",
    component: Default,
  },
  {
    path: '/oauth-callback',
    name: 'oidcCallback',
    component: OidcCallback
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});
router.beforeEach(vuexOidcCreateRouterMiddleware(store))

export default router;
